<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      
    }
  },
  created(){
    
  },
  methods:{
    
  }
}
</script>

<style>
*{margin: 0;padding: 0;list-style: none;font-weight: normal;outline: none;}
html,body{height: 100%;}
#app{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #4d4d4d;
  background: url('assets/bg.jpg') no-repeat;
  background-size: cover;
  background-position: center center;
  min-width: 820px;
  height: 100%;overflow:auto;
}
.go-back{
  color: #fff;width: 80px;
  line-height: 35px;border-radius: 4px;
  text-decoration: none;text-align: center;
  display: inline-block;background-color: #3461ad;
  position: absolute;top: 10px;left: 10px;
}
.top{padding-top: 60px;}
.top img{
  width: 60px;margin:0 auto 14px;display: block;height:30px;
  background: url('assets/logo.png') no-repeat;background-size: cover;
  background-position: center center;
}
.top p{font-size: 18px;}
.box{
  width: 800px;margin: 6% auto 0;border-radius: 10px;
  border: 1px solid #ddd;background: rgba(255,255,255,0.7);
  padding-bottom: 40px;box-sizing: border-box;
}
.toast{
  display: flex;transform: translate(-50%,0);left: 50%;
  position: fixed;opacity: 0;top: 32%;
  animation:move .4s;animation-fill-mode: forwards;
  animation-timing-function:linear;
  box-shadow: 0 0 3px rgba(128,128,128,0.3);
}
.toast i{
  display: inline-block;width: 40px;height: 40px;
  background: #f3a924 url('assets/warn.png') no-repeat;
  background-size: 80%;background-position: center center;
  
}
.toast p{
  background: #fff;font-size: 15px;
  line-height: 40px;height: 40px;padding: 0 10px;
}
@keyframes move{
  100%{opacity: 1;transform: translate(-50%,40px)}
}
@media screen and (max-width: 1300px) {
  .top{padding-top: 20px}
  .box{margin: 2% auto 0}
}
</style>



// WEBPACK FOOTER //
// src/App.vue